import { render } from "./VTab.vue?vue&type=template&id=e72c2964"
import script from "./VTab.vue?vue&type=script&lang=js"
export * from "./VTab.vue?vue&type=script&lang=js"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__